import React from "react";
import { PatternType, randomLightningPattern, randomTwistedStripePattern } from "../types/pattern.model";
import PatternList from "./PatternList";
import { useDispatch, useSelector } from "react-redux";
import { selectPatternType, setPage, setPatternType } from "../store/patternManagerSlice";
import LightningPreview from "../patterns/LightningPreview";
import TwistedStripePreview from "../patterns/TwistedStripePreview";
import { titleize } from "../utils/utils";
import Card from "./Card";

const patternTypes: [PatternType, React.FC][] = [
  ["lightning", () => <LightningPreview {...randomLightningPattern()} />],
  ["twisted-stripe", () => <TwistedStripePreview {...randomTwistedStripePattern()} />]
];

const PatternSelector: React.FC = () => {
  const dispatch = useDispatch();
  const updatePatternType = (patternType: PatternType) => dispatch(setPatternType(patternType));
  const browseCollections = () => dispatch(setPage('collections'));

  return (
    <div className="flex flex-col items-center">
      <p className="text-sm mt-4">Select pattern type:</p>
      <div className="flex justify-center flex-wrap w-full gap-4 mt-2">
        {patternTypes.map(([patternType, Preview]) => (
          <Card className="p-2 w-24">
            <div className="flex flex-col items-center h-full cursor-pointer" onClick={() => updatePatternType(patternType)} key={patternType}>
              <Preview />
              <p className="flex flex-grow items-center justify-center text-xs text-center mt-1">{titleize(patternType)}</p>
            </div>
          </Card>
        ))}
      </div>
      <p className="text-sm underline cursor-pointer mt-6" onClick={browseCollections}>Browse Collections</p>
    </div>
  );
};

const PatternManager: React.FC = () => {
  const patternType = useSelector(selectPatternType);

  return (
    <div className='flex flex-col w-full'>
      {patternType ? 
        <PatternList patternType={patternType} /> : 
        <PatternSelector />
      }
    </div>
  );
};

export default PatternManager;
